import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history/History_of_Sci_&_Tech_-_Space_Race.png';

function HistoryPageSpaceRace() {
  return (
    <TopicPage
      topicKey="Space Race"
      title="History: Space Race"
      backgroundImage={bg}
      startRoute="/History-Space-Race-Go"
      scrollLabels={[
        "Sputnik and Early Satellites",
        "Moon Landing",
        "Cold War Competition in Space",
      ]}
      backRoute="/history-host"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageSpaceRace;
